export const AuthSideBar = {
    LOGIN: 'Log In',
    FORGOTPASS: 'Forgot Password',
    CHANGEPASS: 'Change Password',
    PRIVACYPOLICY: 'Privacy Policy'
};
